export enum PusherEvent {
    SERVER_PING = 'server.ping',
    CART_UPDATED = 'cart.updated',
    BROADCAST_NOTIFICATION_CREATED = 'Illuminate\\Notifications\\Events\\BroadcastNotificationCreated'
}
